
// indexed by 'playerId' in ActivityList
var PlayerList = [
  {
    playerId: 0,
    name: "Tim",
    // TODO:  Image ...
  },
  {
    playerId: 1,
    name: "Maija",
    image: "Maija&Pacman.jpeg",
  },
  {
    playerId: 2,
    name: "Zoe",
  },
  {
    playerId: 3,
    name: "Kathy",
  },
  {
    playerId: 4,
    name: "Peter",
  },
  {
    playerId: 5,
    name: "Sonja",
  },
  {
    playerId: 6,
    name: "Dave",
  },
  {
    playerId: 7,
    name: "Nick",
  },
  {
    playerId: 8,
    name: "Anne",
  },
];

export default PlayerList;



// WEBPACK FOOTER //
// ./src/data/PlayerList.js